<template>
  <span data-bs-toggle="modal" :data-bs-target="theid"><slot></slot></span>
</template>

<script setup>

import {computed, defineProps} from 'vue'

const props = defineProps({
    id: {type:String, required: true}
})

// computed
const theid = computed(() => "#" + props.id)

</script>
